// extracted by mini-css-extract-plugin
module.exports = {"container":"Ads_container__2WQQh","analytics":"Ads_analytics__wOS3I"};